/**
 * Filtre par distance si l’URL contient dest_lat / dest_lon (barre de recherche LocationIQ).
 * Coordonnées produit : data-map-lat / data-map-lon (même convention que collection-map.liquid / Accentuate).
 * Tri : distance croissante sur la page courante (réordonnancement DOM), après filtre rayon.
 * Limite Shopify : la page ne contient que jusqu’à ~250 produits (pagination) — ce n’est pas un tri global catalogue.
 */
(function () {
  'use strict';

  function scheduleSponsoredGridBoost() {
    if (typeof window.LovenBoostSponsoredGrid !== 'function') return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        window.LovenBoostSponsoredGrid({ force: true });
      });
    });
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad;
    var dLon = (lon2 - lon1) * toRad;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  /**
   * Bloc logement = carte .grid-product + modale quick-shop optionnelle (même enfant direct du conteneur).
   */
  function lovenGetGridProductWithTail(card) {
    var out = [card];
    var next = card.nextElementSibling;
    var pid = card.getAttribute('data-product-id');
    if (next && next.classList && next.classList.contains('modal--quick-shop') && pid) {
      if (String(next.getAttribute('data-product-id') || '') === String(pid)) {
        out.push(next);
      }
    }
    return out;
  }

  /**
   * Tri par distance croissante (fiches avec coords), puis fiches visibles sans coords, puis masquées hors rayon.
   * Ne s’applique qu’à la page courante (limite pagination Shopify, typ. 250).
   */
  function lovenSortGridByDistance(ajax, centerLat, centerLon) {
    var grid = ajax.querySelector('.loven-static-collection-grid .new-grid.product-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll(':scope > .grid-item.grid-product[data-product-id]'));
    if (cards.length < 2) return;

    var withDist = [];
    var noCoordVisible = [];
    var rest = [];

    cards.forEach(function (card) {
      var isHidden = card.classList.contains('loven-geo-hidden') || card.style.display === 'none';
      var plat = card.getAttribute('data-map-lat');
      var plon = card.getAttribute('data-map-lon');
      if (isHidden) {
        rest.push(card);
        return;
      }
      if (!plat || !plon) {
        noCoordVisible.push(card);
        return;
      }
      var pLat = parseFloat(plat, 10);
      var pLon = parseFloat(plon, 10);
      if (isNaN(pLat) || isNaN(pLon)) {
        noCoordVisible.push(card);
        return;
      }
      var d = haversineKm(centerLat, centerLon, pLat, pLon);
      withDist.push({ card: card, d: d });
    });

    withDist.sort(function (a, b) {
      return a.d - b.d;
    });

    var order = withDist
      .map(function (x) {
        return x.card;
      })
      .concat(noCoordVisible, rest);

    order.forEach(function (card) {
      lovenGetGridProductWithTail(card).forEach(function (node) {
        grid.appendChild(node);
      });
    });
  }

  function removeNotice() {
    document.querySelectorAll('.loven-dest-filter-notice').forEach(function (el) {
      el.remove();
    });
  }

  window.LovenCollectionDestFilterRun = function () {
    var params = new URLSearchParams(window.location.search);
    var dLat = params.get('dest_lat');
    var dLon = params.get('dest_lon');
    var ajax = document.getElementById('CollectionAjaxContent');
    var hasDest = !!(dLat && dLon);
    var isCollectionZone =
      document.body &&
      document.body.classList.contains('template-collection') &&
      !document.body.classList.contains('template-search');

    document.querySelectorAll('.grid-product.loven-geo-hidden').forEach(function (el) {
      el.classList.remove('loven-geo-hidden');
      el.style.removeProperty('display');
    });

    /* Ne pas effacer le filtre viewport carte sur les collections sans destination URL. */
    if (!isCollectionZone || hasDest) {
      document.querySelectorAll('.grid-product.loven-map-hidden').forEach(function (el) {
        el.classList.remove('loven-map-hidden');
        el.style.removeProperty('display');
      });
      window.__lovenMapViewportFilterActive = false;
      window.__lovenMapViewportVisible = undefined;
    }
    document.body.classList.remove('loven-dest-active');
    removeNotice();

    window.__lovenGeoVisible = undefined;

    /* Recherche Shopify /search : pertinence + facettes, pas un rayon km sur la page courante
       (sinon dest_lat/dest_lon masquent souvent toute la grille + carte vide). Les collections
       /collections/… gardent le filtre rayon. */
    if (document.body.classList.contains('template-search')) {
      if (typeof window.LovenUpdateCollectionResultsCount === 'function') {
        window.LovenUpdateCollectionResultsCount();
      }
      document.dispatchEvent(new CustomEvent('collection:mapSync'));
      scheduleSponsoredGridBoost();
      return;
    }

    if (!dLat || !dLon || !ajax) {
      if (typeof window.LovenUpdateCollectionResultsCount === 'function') {
        window.LovenUpdateCollectionResultsCount();
      }
      document.dispatchEvent(new CustomEvent('collection:mapSync'));
      scheduleSponsoredGridBoost();
      if (isCollectionZone && typeof window.LovenRunMapViewportGridPipeline === 'function') {
        var mapRef = window.__lovenCollectionLeafletMap;
        if (mapRef) {
          requestAnimationFrame(function () {
            window.LovenRunMapViewportGridPipeline(mapRef, { silent: true });
          });
        }
      }
      return;
    }

    var centerLat = parseFloat(dLat, 10);
    var centerLon = parseFloat(dLon, 10);
    if (isNaN(centerLat) || isNaN(centerLon)) {
      if (typeof window.LovenUpdateCollectionResultsCount === 'function') {
        window.LovenUpdateCollectionResultsCount();
      }
      document.dispatchEvent(new CustomEvent('collection:mapSync'));
      scheduleSponsoredGridBoost();
      return;
    }

    var fbRad =
      typeof window.__lovenReadDestRadiusFallbackKm === 'function'
        ? window.__lovenReadDestRadiusFallbackKm()
        : 50;
    var radiusKm = parseFloat(params.get('dest_radius_km') || String(fbRad), 10);
    if (isNaN(radiusKm) || radiusKm <= 0) radiusKm = fbRad;
    /* Ancien défaut thème / URLs enregistrées */
    if (radiusKm === 80) radiusKm = 50;
    radiusKm = Math.min(500, Math.max(5, radiusKm));

    var cards = ajax.querySelectorAll('.grid-product[data-product-id]');
    var visible = 0;
    var usedGeoFallback = false;

    cards.forEach(function (card) {
      var plat = card.getAttribute('data-map-lat');
      var plon = card.getAttribute('data-map-lon');
      if (!plat || !plon) {
        visible++;
        return;
      }
      var pLat = parseFloat(plat, 10);
      var pLon = parseFloat(plon, 10);
      if (isNaN(pLat) || isNaN(pLon)) {
        visible++;
        return;
      }
      var d = haversineKm(centerLat, centerLon, pLat, pLon);
      if (d <= radiusKm) {
        visible++;
      } else {
        card.classList.add('loven-geo-hidden');
        card.style.display = 'none';
      }
    });

    /*
     * Sans dates, l’URL peut quand même contenir dest_lat / dest_lon (recherche ou lien enregistré).
     * Si tous les produits de la page ont des coords et sont hors rayon → visible === 0 : grille vide.
     * On réaffiche tout pour éviter une page blanche (pagination / carte inutilisable).
     */
    if (visible === 0 && cards.length > 0) {
      usedGeoFallback = true;
      cards.forEach(function (card) {
        card.classList.remove('loven-geo-hidden');
        card.style.removeProperty('display');
      });
      visible = cards.length;
      if (new URLSearchParams(window.location.search).get('loven_debug') === '1') {
        console.info(
          '[Loven] Filtre destination — aucun logement dans le rayon sur cette page : affichage de toute la grille (fallback).'
        );
      }
    }

    window.__lovenGeoVisible = visible;
    if (usedGeoFallback) {
      document.body.classList.remove('loven-dest-active');
    } else {
      document.body.classList.add('loven-dest-active');
    }

    lovenSortGridByDistance(ajax, centerLat, centerLon);

    if (typeof window.LovenUpdateCollectionResultsCount === 'function') {
      window.LovenUpdateCollectionResultsCount();
    }
    if (new URLSearchParams(window.location.search).get('loven_debug') === '1') {
      console.info('[Loven] Filtre destination — visible sur cette page:', visible, '— rayon', radiusKm, 'km');
    }
    document.dispatchEvent(new CustomEvent('collection:destFiltered'));
    document.dispatchEvent(new CustomEvent('collection:mapSync'));
    scheduleSponsoredGridBoost();
  };

  document.addEventListener('DOMContentLoaded', function () {
    window.LovenCollectionDestFilterRun();
  });
  document.addEventListener('collection:reloaded', function () {
    window.LovenCollectionDestFilterRun();
  });
})();
